module.exports = __webpack_public_path__ + "static/media/pullDown.c6ef2a27.svg";